export default __webpack_public_path__ + "static/media/3.fd045f85.svg";